import { render, staticRenderFns } from "./noResultsFound.vue?vue&type=template&id=71b083b8&scoped=true&"
import script from "./noResultsFound.vue?vue&type=script&lang=js&"
export * from "./noResultsFound.vue?vue&type=script&lang=js&"
import style0 from "./noResultsFound.vue?vue&type=style&index=0&id=71b083b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b083b8",
  null
  
)

export default component.exports